const initialState = {
  fieldConfig: null
};

// Holds the company's document field configuration — the four buckets returned by
// get-document-field-configuration (content, lineItems, codes, paymentDetails),
// flattened to one name → enabled map.
//
// This replaces eight company permission flags (the construction-company flag, the phase flag,
// the work-order flag, the service-code/equipment flag, the GL-division flag,
// the payment-terms flag, the shipping-address flag and
// the misc-amount flag). Where the app used to ask "does this
// company have the phase permission", it now asks "is userPhases enabled", which is
// the same question asked of the field itself.
//
// `null` means not loaded yet, which is not the same as "everything off" — see
// isFieldEnabled. Full-replace, and wiped on logout so an account switch can never
// read the previous company's fields.
const FieldConfigReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'fieldConfig':
      return {
        ...state,
        fieldConfig: action.payload
      };
    case 'clearFieldConfig':
      return initialState;
    default:
      return state;
  }
};
export default FieldConfigReducer;
